module.exports = __webpack_public_path__ + "img/webcartography.afb359b0.svg";